const FinalizarAvisosVencimentoContrato = () =>
    import('./FinalizarAvisosVencimentoContrato.vue')
const FinalizarAvisosSaldoContrato = () =>
    import('./FinalizarAvisosSaldoContrato.vue')
const FinalizarAvisosSaldoItemContrato = () =>
    import('./FinalizarAvisosSaldoItemContrato.vue')
const FinalizarAvisosContratoSemMovimentacao = () =>
    import('./FinalizarAvisosContratoSemMovimentacao.vue')
const FinalizarAvisosComprometimentoSemRegistroPagamento = () =>
    import('./FinalizarAvisosComprometimentoSemRegistroPagamento.vue')

export default {
    path: 'processos',
    name: 'Processos',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'finalizaravisosvencimentocontrato',
            name: 'FinalizarAvisosVencimentoContrato',
            component: FinalizarAvisosVencimentoContrato,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisossaldocontrato',
            name: 'FinalizarAvisosSaldoContrato',
            component: FinalizarAvisosSaldoContrato,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisossaldoitemcontrato',
            name: 'FinalizarAvisosSaldoItemContrato',
            component: FinalizarAvisosSaldoItemContrato,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisoscontratosemmovimentacao',
            name: 'FinalizarAvisosContratoSemMovimentacao',
            component: FinalizarAvisosContratoSemMovimentacao,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'finalizaravisoscomprometimentosemregistropagamento',
            name: 'FinalizarAvisosComprometimentoSemRegistroPagamento',
            component: FinalizarAvisosComprometimentoSemRegistroPagamento,
            beforeEnter: (to, from, next) => {
                next()
            }
        }
    ]
}
